import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTempoFullColorDkGray = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 739.46 229",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("style", { children: ".cls-1,.cls-3{fill:none;}.cls-2{fill:#fff;}.cls-10,.cls-11,.cls-12,.cls-2,.cls-3,.cls-9{stroke:#231f20;}.cls-3{stroke-width:2px;}.cls-12,.cls-4{fill:#363636;}.cls-5{clip-path:url(#clip-path);}.cls-10,.cls-6{fill:#25397a;}.cls-7,.cls-9{fill:#0071b2;}.cls-11,.cls-8{fill:#b1b1b3;}.cls-13{fill:#231f20;}" }), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip-path",
		children: /* @__PURE__ */ _jsx("path", {
			id: "SVGID",
			className: "cls-1",
			d: "M178.94,127.59c-24.46,26.29-32.86,36.25-36.61-31.39-2.47-.29-1.48-2.65-4.14-3.26-62.45-14.27-73.77,11-32.41-33.43,43.81-47.08,35.74-48.17,42.33,28.06C230,89.08,222.75,80.51,178.94,127.59Z"
		})
	})] }), /* @__PURE__ */ _jsxs("g", {
		id: "Abstract",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				className: "cls-2",
				cx: 122.42,
				cy: 115.66,
				r: 103.73,
				transform: "translate(-6.38 7.15) rotate(-3.26)"
			}),
			/* @__PURE__ */ _jsx("circle", {
				className: "cls-3",
				cx: 122.42,
				cy: 115.66,
				r: 74.74,
				transform: "translate(-22.39 29.67) rotate(-12.67)"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-4",
				d: "M307.72,166.73h-12.8V75.81H265.67V64.59h71.38V75.81H307.72Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-4",
				d: "M417.34,155.5v11.23H351.27V64.59h64.65V75.81H364.06v32.48h41.16v10.4H364.06V155.5Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-4",
				d: "M533.84,166.73H521.42V77.54l-33.16,89.19h-8.68L446.07,77.54v89.19H435.22V64.59h18.94L485,146.28l30.12-81.69h18.7Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-4",
				d: "M572.15,166.73h-12.8V64.59h36.22q17,0,25.06,9.24a31.08,31.08,0,0,1,8.08,21.06q0,13.17-8.79,21.78t-23,8.6H572.15Zm0-52.08h23.49q9.06,0,14.59-5.43t5.54-14.33a20.82,20.82,0,0,0-4.94-13.61q-4.94-6-14.29-6H572.15Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-4",
				d: "M680.27,168.82q-19.68,0-30.68-15.31t-11-37.55q0-23.22,11.52-38.34T680.64,62.5q18.93,0,30.38,14.86t11.45,37.48q0,21.71-11.11,37.85T680.27,168.82Zm.3-10.4q13.39,0,20.95-12.21t7.55-31.45q0-19.77-7.82-30.78T680.49,73q-13.1,0-20.8,11.91T652,116q0,18.79,7.78,30.59T680.57,158.42Z"
			}),
			/* @__PURE__ */ _jsxs("g", {
				className: "cls-5",
				children: [
					/* @__PURE__ */ _jsx("path", {
						className: "cls-6",
						d: "M142.45,140.78a47.15,47.15,0,1,1,34.51-15,47,47,0,0,1-34.51,15Zm0-89.8A42.67,42.67,0,1,0,185.1,92.11,42.66,42.66,0,0,0,142.47,51Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "cls-7",
						d: "M142.45,130.83A37.2,37.2,0,1,1,169.68,119a37.12,37.12,0,0,1-27.23,11.85Zm0-69.91a32.83,32.83,0,0,0-24,10.43,32.73,32.73,0,0,0,23.95,55,32.85,32.85,0,0,0,24-10.43,32.73,32.73,0,0,0-23.95-55Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "cls-8",
						d: "M142.45,120a26.3,26.3,0,1,1,19.27-8.38A26.17,26.17,0,0,1,142.45,120Zm0-48.15a21.94,21.94,0,0,0-16,7,21.85,21.85,0,0,0,16,36.73,21.85,21.85,0,1,0,0-43.69Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "cls-8",
						d: "M142.46,109.55a15.92,15.92,0,1,1,11.64-5.07,15.86,15.86,0,0,1-11.64,5.07Zm0-27.35a11.31,11.31,0,0,0-8.37,3.65,11.43,11.43,0,0,0,8.37,19.23,11.44,11.44,0,0,0,0-22.88Z"
					})
				]
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-9",
				x: 87.74,
				y: 149.2,
				width: 27.21,
				height: 27.21
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-10",
				x: 87.74,
				y: 121.99,
				width: 27.21,
				height: 27.21
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-11",
				x: 87.74,
				y: 94.77,
				width: 27.21,
				height: 27.21
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-2",
				x: 114.96,
				y: 94.77,
				width: 27.21,
				height: 27.21
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-12",
				x: 114.96,
				y: 121.99,
				width: 27.21,
				height: 27.21
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-2",
				x: 60.53,
				y: 121.99,
				width: 27.21,
				height: 27.21
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M34.29,156.13l-.75-2,5.57-5.29-1.63-4.38-6.62,2.47-.67-1.79,15.29-5.71,2.25,6a4.9,4.9,0,0,1,0,4.13,4.67,4.67,0,0,1-2.49,2.28,4.91,4.91,0,0,1-2.59.21,4,4,0,0,1-2.42-1.59ZM39,143.87l1.49,4a3.26,3.26,0,0,0,1.71,2,3.06,3.06,0,0,0,2.34,0,2.46,2.46,0,0,0,1.58-1.53,3.37,3.37,0,0,0-.11-2.33l-1.58-4.23Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M42.71,167.85l-1.57.88L36,159.51l14.26-8,5,9-1.57.87-4-7.23-4.53,2.53,3.2,5.74-1.45.81-3.21-5.74-5.13,2.87Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M45.5,167.62l1.46,1.2a4.6,4.6,0,0,0,.3,5.86,4.53,4.53,0,0,0,2.44,1.81,2.73,2.73,0,0,0,2.34-.57,2.15,2.15,0,0,0,.88-1.62,4.1,4.1,0,0,0-.37-1.91l-1.36-3.07a8.91,8.91,0,0,1-.65-2.12,3.84,3.84,0,0,1,.29-2,4.3,4.3,0,0,1,1.39-1.78,4,4,0,0,1,3.53-.78,6.22,6.22,0,0,1,3.38,2.39,5.64,5.64,0,0,1,.39,7.1L58,171a3.31,3.31,0,0,0,.79-2.53,4.81,4.81,0,0,0-1-2.47,4.08,4.08,0,0,0-2-1.45,2.29,2.29,0,0,0-2.23.39c-.95.74-1.06,1.94-.31,3.6l1.3,2.86c1.17,2.61.83,4.64-1,6.07a4.57,4.57,0,0,1-3.75.91,6.4,6.4,0,0,1-3.82-2.65A6.48,6.48,0,0,1,45.5,167.62Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M53.83,184.39,52.35,183l11.31-11.78,4.18,4a5,5,0,0,1,1.86,3.84,4.94,4.94,0,0,1-1.4,3.32,4.69,4.69,0,0,1-3.42,1.54,5.05,5.05,0,0,1-3.61-1.56l-2.85-2.74Zm5.76-6L62.3,181a3.19,3.19,0,0,0,2.29,1,3,3,0,0,0,2.22-1,3.36,3.36,0,0,0,.94-2.12,2.81,2.81,0,0,0-1-2.27L64,173.84Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M67.67,196.43A5.69,5.69,0,0,1,65,191.62a9.94,9.94,0,0,1,2-5.93,9.79,9.79,0,0,1,5-4,6.14,6.14,0,0,1,8,5.5,9.54,9.54,0,0,1-1.9,6,10.39,10.39,0,0,1-4.91,4A5.69,5.69,0,0,1,67.67,196.43Zm1-1.34a3.77,3.77,0,0,0,3.87.3,9.36,9.36,0,0,0,3.85-3.45,8.45,8.45,0,0,0,1.78-4.75,3.9,3.9,0,0,0-1.73-3.34,3.82,3.82,0,0,0-3.82-.33,9.16,9.16,0,0,0-3.85,3.39A8.81,8.81,0,0,0,67,191.64,3.83,3.83,0,0,0,68.65,195.09Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M87.8,207l-1.8-.84-1.67-16.46-.43,1c-.15.38-.28.7-.4,1l-5.11,11-1.49-.69,6.87-14.81,2.32,1.08,1.56,15.39.46-1c.17-.41.33-.77.47-1.09l4.63-10,1.46.68Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M92,204l1.89.09a4.59,4.59,0,0,0,3.75,4.5,4.53,4.53,0,0,0,3,0,2.77,2.77,0,0,0,1.53-1.87,2.12,2.12,0,0,0-.27-1.81,4.12,4.12,0,0,0-1.44-1.31L97.58,202a8.65,8.65,0,0,1-1.79-1.31,3.75,3.75,0,0,1-.94-1.74,4.14,4.14,0,0,1,0-2.26,3.91,3.91,0,0,1,2.35-2.73,6.18,6.18,0,0,1,4.14-.12,5.63,5.63,0,0,1,4.57,5.44l-1.93,0a3.31,3.31,0,0,0-.89-2.5,4.75,4.75,0,0,0-2.26-1.39,4.14,4.14,0,0,0-2.49.05,2.27,2.27,0,0,0-1.54,1.66c-.33,1.16.31,2.19,1.9,3.07l2.75,1.5q3.77,2.09,2.84,5.46a4.57,4.57,0,0,1-2.46,3A7.32,7.32,0,0,1,92,204Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M117.4,211.67l-.22,1.78-10.48-1.28,2-16.21,10.26,1.26-.22,1.78-8.23-1-.63,5.16,6.53.8-.2,1.65-6.53-.8-.71,5.84Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M150.7,209.73l-2.1.46L144.13,204l-4.57,1,1.54,6.9-1.87.42-3.56-15.94L142,195a4.88,4.88,0,0,1,4.09.55,4.62,4.62,0,0,1,1.92,2.78,4.79,4.79,0,0,1-.15,2.59,3.94,3.94,0,0,1-1.9,2.18Zm-11.5-6.38,4.17-.93a3.31,3.31,0,0,0,2.26-1.42,3.07,3.07,0,0,0,.33-2.31,2.44,2.44,0,0,0-1.29-1.77,3.41,3.41,0,0,0-2.32-.22l-4.42,1Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M163.44,203l.65,1.67-9.84,3.84-5.93-15.22,9.63-3.75.65,1.68-7.72,3,1.88,4.84,6.13-2.39.61,1.55-6.13,2.39,2.13,5.48Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M172.44,193.83l1.83-.55q1.5,5.35-2.61,7.68a5.65,5.65,0,0,1-5.46.21,10.39,10.39,0,0,1-4.57-4.49,9.4,9.4,0,0,1-1.37-6.18,6,6,0,0,1,3.18-4.42q4-2.25,7.72,1.67L169.67,189q-2.83-2.86-5.39-1.43a3.8,3.8,0,0,0-2,3.22,9.15,9.15,0,0,0,1.47,5,8.42,8.42,0,0,0,3.43,3.59,3.7,3.7,0,0,0,3.7,0Q173.57,197.89,172.44,193.83Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M184.32,192.33A5.71,5.71,0,0,1,179,193.5a10,10,0,0,1-5.13-3.58,9.87,9.87,0,0,1-2.41-5.93,6.14,6.14,0,0,1,7.56-6.13,9.55,9.55,0,0,1,5.19,3.52,10.33,10.33,0,0,1,2.4,5.83A5.67,5.67,0,0,1,184.32,192.33Zm-1-1.33a3.74,3.74,0,0,0,1.39-3.61,9.51,9.51,0,0,0-2.21-4.68,8.37,8.37,0,0,0-4.06-3.05,3.88,3.88,0,0,0-3.69.71,3.79,3.79,0,0,0-1.4,3.57,9.12,9.12,0,0,0,2.16,4.65,8.74,8.74,0,0,0,4,3A3.81,3.81,0,0,0,183.31,191Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M187.18,166.24l8.29,15.1-1.34,1.45-15.74-7,1.45-1.58,13,5.77L186,167.55Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M205.36,165.27l1.47,1-6,8.71-13.46-9.24,5.84-8.52,1.48,1L190,165.09l4.28,2.93L198,162.6l1.38.94L195.68,169l4.86,3.33Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M213.57,152.89l-.94,1.92-7.67-.37-2,4.21,6.36,3.08-.84,1.72-14.69-7.12,2.81-5.79a4.92,4.92,0,0,1,3-2.87,4.67,4.67,0,0,1,3.37.23,4.87,4.87,0,0,1,1.94,1.73,4,4,0,0,1,.52,2.84Zm-12.15,5,1.86-3.84a3.21,3.21,0,0,0,.3-2.65,3.06,3.06,0,0,0-1.6-1.7,2.43,2.43,0,0,0-2.19-.09,3.4,3.4,0,0,0-1.62,1.68l-2,4.07Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M202.43,134.33l7.37,8.07,6.55,2.07-.62,1.95-6.54-2.07-10.67,2.36.73-2.31,8.46-1.87-5.84-6.42Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M41.71,107.08l0,2-14.26-.29,14.15,5.59,0,1.39-14.37,5.06,14.26.29,0,1.74-16.32-.34.06-3,13.16-4.66-13-5.08.06-3Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M42.73,102.56l-.32,2L26.29,102l.32-2Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M44.42,95l-.52,2L29.84,93.31l-1.18,4.53-1.74-.45,2.87-11,1.74.45-1.18,4.54Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M46.82,87.6l-.7,1.92L30.78,83.94l.7-1.93Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M45.77,70.43l7.55,3.81-.57,1.11-2.08-.42a5.11,5.11,0,0,1-.1,5,5.9,5.9,0,0,1-4.43,3.39,9.61,9.61,0,0,1-6.08-1.06,9.82,9.82,0,0,1-4.66-4.48A6.15,6.15,0,0,1,35.51,72q2-4,6.88-3.12l-.45,1.94a4.25,4.25,0,0,0-3.07.21A4.18,4.18,0,0,0,37,72.93,3.85,3.85,0,0,0,37.14,77,9.53,9.53,0,0,0,41,80.22a8.39,8.39,0,0,0,5,1.09A4.07,4.07,0,0,0,49.17,79a3.92,3.92,0,0,0,.28-3.08,4.24,4.24,0,0,0-2.3-2.45c-.22-.12-.49-.24-.8-.38l-1.83,3.61L43,75.91Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M61,63.16l-1.23,1.69L55,63.38l-3.57,4.89,3,4-1,1.39L43.3,59.75l1.36-1.87Zm-7.55-.33-7.83-2.57,4.86,6.66Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M64.12,60.08l-1.39,1.5L52.07,51.7,48.9,55.13l-1.32-1.22,7.76-8.37,1.31,1.22L53.46,50.2Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M69.75,54.69l-1.52,1.36L57.35,43.87l1.53-1.36Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M76.58,49.76a5.72,5.72,0,0,1-5.42.83,10,10,0,0,1-4.9-3.9,9.8,9.8,0,0,1-2-6.07A6.13,6.13,0,0,1,72.17,35a9.52,9.52,0,0,1,5,3.84,10.4,10.4,0,0,1,2,6A5.67,5.67,0,0,1,76.58,49.76Zm-.92-1.38a3.76,3.76,0,0,0,1.61-3.53A9.45,9.45,0,0,0,75.36,40a8.41,8.41,0,0,0-3.85-3.3,3.87,3.87,0,0,0-3.73.48,3.78,3.78,0,0,0-1.62,3.47A9.05,9.05,0,0,0,68,45.47a8.71,8.71,0,0,0,3.84,3.28A3.83,3.83,0,0,0,75.66,48.38Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M94.16,39.73l-1.8.85-13.7-9.27.48,1c.19.36.35.66.47.92l5.17,11-1.49.7-7-14.77L78.64,29l12.81,8.67-.5-1c-.21-.4-.38-.75-.53-1.06l-4.68-9.94L87.2,25Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M109,35.77l-2,.3-2.38-16.16,5.73-.84a5.05,5.05,0,0,1,4.18.88,5,5,0,0,1,1.77,3.15,4.64,4.64,0,0,1-.89,3.64,5,5,0,0,1-3.44,1.9l-3.91.57Zm-1.21-8.24,3.72-.54a3.19,3.19,0,0,0,2.18-1.2,3.05,3.05,0,0,0,.54-2.39,3.28,3.28,0,0,0-1.1-2,2.79,2.79,0,0,0-2.4-.62l-3.85.57Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M130.62,34.56l-2.14,0-2.94-7.09-4.68-.05-.07,7.07-1.91,0L119,18.11l6.43.07a4.89,4.89,0,0,1,3.87,1.46,4.67,4.67,0,0,1,1.23,3.15,4.85,4.85,0,0,1-.73,2.49A4,4,0,0,1,127.49,27Zm-9.74-8.83,4.27,0a3.26,3.26,0,0,0,2.52-.87,3.07,3.07,0,0,0,.86-2.17,2.46,2.46,0,0,0-.86-2,3.42,3.42,0,0,0-2.21-.74l-4.52,0Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M142.92,34.69l-.28,1.77-10.43-1.67,2.58-16.12L145,20.3l-.28,1.77-8.18-1.31-.82,5.13,6.49,1-.26,1.64-6.5-1-.93,5.81Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M145.71,37.42l-2-.62,4.88-15.58L154.17,23a5.08,5.08,0,0,1,3.38,2.6,4.94,4.94,0,0,1,.22,3.6,4.64,4.64,0,0,1-2.38,2.9,5,5,0,0,1-3.92.22l-3.78-1.19Zm2.49-8,3.58,1.12a3.22,3.22,0,0,0,2.49-.12,3.09,3.09,0,0,0,1.53-1.93,3.35,3.35,0,0,0-.1-2.31,2.83,2.83,0,0,0-1.9-1.6l-3.72-1.16Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M164.59,45.06l-1.89-.89.55-5-5.48-2.58-3.35,3.69-1.55-.73L164.63,27l2.09,1Zm-1.08-7.48,1.06-8.18-5.63,6Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M175,52.09l-1.78-1.2,1.47-7.54-3.87-2.62-4,5.85-1.59-1.07L174.38,32l5.32,3.61A4.9,4.9,0,0,1,182.12,39a4.64,4.64,0,0,1-.71,3.29,4.89,4.89,0,0,1-2,1.68,4,4,0,0,1-2.89.11ZM171.7,39.35l3.54,2.4a3.28,3.28,0,0,0,2.58.67,3.1,3.1,0,0,0,1.92-1.34,2.45,2.45,0,0,0,.39-2.16,3.33,3.33,0,0,0-1.43-1.84L175,34.55Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M185.12,59.06l-1.22,1.32-7.75-7.18,11.09-12,7.58,7-1.21,1.31-6.09-5.63L184,47.74l4.82,4.47-1.13,1.22L182.87,49l-4,4.32Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M184.64,61.19l12.82-10.12,3.39,4.3a6.57,6.57,0,0,1,1.49,5.69A8.84,8.84,0,0,1,199,66.14a9.1,9.1,0,0,1-5.74,2.14A5.84,5.84,0,0,1,188.45,66Zm2.63.53,2.06,2.6a4.65,4.65,0,0,0,3.9,2,7.83,7.83,0,0,0,4.61-1.9,7.63,7.63,0,0,0,2.6-3.71,4.56,4.56,0,0,0-1-4.38l-2.06-2.6Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M199,83.06l-.94-1.74,8.52-14.19-.93.53c-.35.22-.64.39-.89.52l-10.68,5.76-.78-1.46,14.37-7.74L208.89,67l-8,13.26,1-.56c.38-.22.72-.42,1-.58l9.67-5.21.77,1.42Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M205.05,94.77l-1.7.58-3.45-10L215.33,80l3.38,9.76-1.7.59-2.71-7.83-4.9,1.7,2.15,6.21L210,91l-2.16-6.22-5.56,1.93Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M207.59,94.27l.74,1.74a4.59,4.59,0,0,0-2.4,5.34,4.41,4.41,0,0,0,1.34,2.72,2.72,2.72,0,0,0,2.34.57,2.15,2.15,0,0,0,1.52-1,4.14,4.14,0,0,0,.54-1.86l.2-3.36a8.17,8.17,0,0,1,.4-2.18,3.75,3.75,0,0,1,1.14-1.61,4.31,4.31,0,0,1,2.06-1,3.93,3.93,0,0,1,3.49.93,6.17,6.17,0,0,1,1.91,3.67,5.61,5.61,0,0,1-2.9,6.48l-.88-1.72a3.26,3.26,0,0,0,1.86-1.89,4.7,4.7,0,0,0,.26-2.64,4.15,4.15,0,0,0-1.13-2.22,2.27,2.27,0,0,0-2.16-.66c-1.19.22-1.83,1.24-1.93,3l-.15,3.14c-.15,2.86-1.38,4.51-3.67,4.93a4.51,4.51,0,0,1-3.75-.9,7.32,7.32,0,0,1,1.17-11.54Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-13",
				d: "M210.05,107.75l.47,1.83a4.61,4.61,0,0,0-3.22,4.91,4.53,4.53,0,0,0,.9,2.9,2.76,2.76,0,0,0,2.23.92,2.11,2.11,0,0,0,1.66-.79,4.11,4.11,0,0,0,.83-1.75l.72-3.29a8.85,8.85,0,0,1,.73-2.09,3.9,3.9,0,0,1,1.39-1.41,4.24,4.24,0,0,1,2.18-.61,3.93,3.93,0,0,1,3.3,1.46,6.2,6.2,0,0,1,1.31,3.92,5.62,5.62,0,0,1-3.88,6l-.59-1.84a3.25,3.25,0,0,0,2.13-1.57,4.8,4.8,0,0,0,.67-2.57,4.11,4.11,0,0,0-.77-2.36,2.28,2.28,0,0,0-2-1c-1.21,0-2,.94-2.39,2.72l-.64,3.07c-.59,2.8-2.06,4.24-4.4,4.3a4.53,4.53,0,0,1-3.56-1.49,7.32,7.32,0,0,1,3-11.21Z"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgTempoFullColorDkGray);
export { ForwardRef as ReactComponent };
